export default "/images/ifforsikringsagentur.png?ced78a2893a59aaf6a94f3cda905673c";